import React from "react";
import { TableTdProps } from "./Table.types";
import { Layout } from "./Td.styles";
import { TableCheckbox } from "./TableCheckbox";

/**
 * Table cell component
 */
export const Td = ({
  children,
  id,
  onCheckedChanged,
  checked,
  label,
  ...props
}: TableTdProps) => (
  <Layout {...props}>
    {onCheckedChanged && (
      <TableCheckbox
        id={`checkbox_${id}`}
        forId={`checkbox_${id}`}
        label={label}
        checked={!!checked}
        onCheckedChange={onCheckedChanged}
      />
    )}
    {children}
  </Layout>
);
